// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hide the default upload icon */
:host ::ng-deep .p-fileupload-choose .p-button-icon {
  display: none !important;
}

:host ::ng-deep .p-fileupload-choose .p-button-label {
  margin-left: 0 !important;
}

:root {
  --primary: #e56900;
  --secondary: #008DD2;
}

.bank-card {
  background: linear-gradient(135deg, #ffffff, #f4fbfc);
  border-radius: 16px;
  padding: 1rem;
  height: 100%;
  border-left: 5px solid var(--primary);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  transition: all 0.25s ease;
}

.bank-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.12);
}

.bank-card-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  padding-bottom: 0.75rem;
  margin-bottom: 0.75rem;
}

.account-name {
  font-size: 1rem;
  font-weight: 600;
  color: var(--primary);
}

.bank-name {
  font-size: 0.8rem;
  color: var(--secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.bank-card-body .info-row {
  display: flex;
  justify-content: space-between;
  padding: 0.35rem 0;
  font-size: 0.85rem;
}

.bank-card-body .info-row span {
  color: #6c757d;
}

.bank-card-body .info-row strong {
  color: #212529;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/app/payment/payment.component.scss"],"names":[],"mappings":"AAAA,iCAAA;AACA;EACI,wBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,qDAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,qCAAA;EACA,0CAAA;EACA,0BAAA;AACJ;;AAEA;EACI,2BAAA;EACA,2CAAA;AACJ;;AAEA;EACI,4CAAA;EACA,uBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,cAAA;EACA,gBAAA;AACJ","sourcesContent":["/* Hide the default upload icon */\r\n:host ::ng-deep .p-fileupload-choose .p-button-icon {\r\n    display: none !important;\r\n}\r\n\r\n:host ::ng-deep .p-fileupload-choose .p-button-label {\r\n    margin-left: 0 !important;\r\n}\r\n\r\n:root {\r\n    --primary: #e56900;\r\n    --secondary: #008DD2;\r\n}\r\n\r\n.bank-card {\r\n    background: linear-gradient(135deg, #ffffff, #f4fbfc);\r\n    border-radius: 16px;\r\n    padding: 1rem;\r\n    height: 100%;\r\n    border-left: 5px solid var(--primary);\r\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);\r\n    transition: all 0.25s ease;\r\n}\r\n\r\n.bank-card:hover {\r\n    transform: translateY(-6px);\r\n    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.bank-card-header {\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.06);\r\n    padding-bottom: 0.75rem;\r\n    margin-bottom: 0.75rem;\r\n}\r\n\r\n.account-name {\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    color: var(--primary);\r\n}\r\n\r\n.bank-name {\r\n    font-size: 0.8rem;\r\n    color: var(--secondary);\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n}\r\n\r\n.bank-card-body .info-row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 0.35rem 0;\r\n    font-size: 0.85rem;\r\n}\r\n\r\n.bank-card-body .info-row span {\r\n    color: #6c757d;\r\n}\r\n\r\n.bank-card-body .info-row strong {\r\n    color: #212529;\r\n    font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
